import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const AdminNewsPage = () => {
  const [news, setNews] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const itemsPerPage = 5;
  const token = localStorage.getItem("admin_jwt");

  useEffect(() => {
    const fetchNews = async () => {
      try {
        // GET /api/admin/news?page=1&limit=5 で一覧取得
        const res = await fetch(
          `/api/admin/news?page=${page}&limit=${itemsPerPage}`,
          {
            headers: {
              "Authorization": `Bearer ${token}`,
            },
          }
        );
        const data = await res.json();

        // 正常時：data.dataは配列
        if (Array.isArray(data.data)) {
          setNews(data.data);
          setTotal(data.total || 0);
        } else if (Array.isArray(data)) {
          // もしdata自体が配列なら（API変更時の保険）
          setNews(data);
          setTotal(data.length);
        } else {
          // 失敗時
          console.error("Invalid data format", data);
          setNews([]);
          setTotal(0);
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setNews([]);
        setTotal(0);
      }
    };

    fetchNews();
  }, [page, token]); // tokenが変わった場合もfetch

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h1 className="adm-title">お知らせ一覧</h1>
        <Link to="/admin/news/new" className="adm-btn">
          ＋ 追加
        </Link>
      </div>

      <div className="adm-card p-0 overflow-hidden">
        <ul className="divide-y divide-gray-100">
          {news.map((item) => (
            <li key={item.id}>
              <Link
                to={`/admin/news/${item.id}`}
                className="block px-4 py-3 hover:bg-gray-50 transition"
              >
                <p className="text-xs text-gray-500">
                  {item.createdAt
                    ? new Date(item.createdAt).toLocaleDateString("ja-JP", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                      })
                    : ""}
                </p>
                <span className="font-medium text-gray-800">{item.title}</span>
              </Link>
            </li>
          ))}
          {news.length === 0 && (
            <li className="px-4 py-8 text-center text-gray-400 text-sm">
              お知らせがありません
            </li>
          )}
        </ul>
      </div>

      <div className="mt-4 flex gap-2 flex-wrap">
        {Array.from({ length: Math.ceil(total / itemsPerPage) }, (_, i) => (
          <button
            key={i}
            onClick={() => setPage(i + 1)}
            className={`px-3 py-1 rounded-md text-sm ${
              page === i + 1
                ? "bg-primary text-white"
                : "bg-gray-100 text-gray-700 hover:bg-gray-200"
            }`}
          >
            {i + 1}
          </button>
        ))}
      </div>
    </div>
  );
};

export default AdminNewsPage;
